import React from 'react';

const GameCard = ({ game, userRole, onDelete, onPlayGame }) => {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'educational': return '📚';
      case 'fun': return '🎉';
      case 'puzzle': return '🧩';
      default: return '🎮';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'educational': return '#4CAF50';
      case 'fun': return '#FF9800';
      case 'puzzle': return '#9C27B0';
      default: return '#2196F3';
    }
  };

  const handlePlayGame = () => {
    if (onPlayGame) {
      onPlayGame(game);
    } else {
      window.open(game.gameUrl, '_blank');
    }
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '8px',
      padding: '12px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
      border: '1px solid #e2e8f0',
      transition: 'all 0.3s ease',
      fontFamily: 'Georgia, serif',
      position: 'relative',
      overflow: 'hidden',
      height: 'fit-content',
      minHeight: '200px',
      display: 'flex',
      flexDirection: 'column'
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.transform = 'translateY(-4px)';
      e.currentTarget.style.boxShadow = '0 8px 25px rgba(30, 64, 175, 0.15)';
      e.currentTarget.style.borderColor = '#1e40af';
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      e.currentTarget.style.borderColor = '#e2e8f0';
    }}
    >
      {/* Decorative top border */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: `linear-gradient(90deg, ${getCategoryColor(game.category)}, #1e40af)`
      }} />
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
        <div style={{
          background: `linear-gradient(135deg, ${getCategoryColor(game.category)}, #1e40af)`,
          color: 'white',
          padding: '6px 12px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '600',
          fontFamily: 'Georgia, serif',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          {getCategoryIcon(game.category)} {game.category.charAt(0).toUpperCase() + game.category.slice(1)}
        </div>
        {onDelete && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(game._id);
            }}
            style={{
              background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(220, 38, 38, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            title="Delete Game"
          >
            ×
          </button>
        )}
      </div>

      <h3 style={{ 
        margin: '0 0 8px 0', 
        color: '#1e40af',
        fontSize: '18px',
        fontWeight: '600',
        fontFamily: 'Georgia, serif',
        lineHeight: '1.2'
      }}>
        {game.title}
      </h3>

      <p style={{ 
        color: '#64748b', 
        fontSize: '14px', 
        lineHeight: '1.4',
        margin: '0 0 12px 0',
        minHeight: '40px',
        fontFamily: 'Georgia, serif',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden'
      }}>
        {game.description}
      </p>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: '8px', 
        marginBottom: '12px',
        padding: '12px',
        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
        borderRadius: '8px',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{ 
          fontSize: '12px', 
          color: '#475569',
          fontFamily: 'Georgia, serif',
          fontWeight: '500'
        }}>
          <div style={{ marginBottom: '2px' }}>👥 {game.targetClass || 'All'}</div>
          <div>📅 {new Date(game.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</div>
        </div>
        <div style={{ 
          fontSize: '12px', 
          color: '#475569',
          fontFamily: 'Georgia, serif',
          fontWeight: '500',
          textAlign: 'right'
        }}>
          <div>🎯 {game.difficulty || 'Medium'}</div>
          <div style={{ marginTop: '4px' }}>👨‍🏫 {game.createdBy || 'Teacher'}</div>
        </div>
      </div>

      <button
        onClick={() => handlePlayGame()}
        style={{
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          color: 'white',
          border: 'none',
          padding: '10px 16px',
          borderRadius: '12px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '600',
          fontFamily: 'Georgia, serif',
          width: '100%',
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 12px rgba(30, 64, 175, 0.2)',
          textTransform: 'none',
          letterSpacing: '0.5px'
        }}
        onMouseOver={(e) => {
          e.target.style.background = 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(30, 64, 175, 0.3)';
        }}
        onMouseOut={(e) => {
          e.target.style.background = 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 12px rgba(30, 64, 175, 0.2)';
        }}
      >
        🎮 Launch Game
      </button>
    </div>
  );
};

export default GameCard;